import { cn } from "@/utils/styles";

type SignupStepPrimaryButtonProps = {
  disabled?: boolean;
  children: React.ReactNode;
  active?: boolean;
  onClick?: () => void;
};

export const SignupStepPrimaryButton: React.FC<SignupStepPrimaryButtonProps> = ({
  disabled = false,
  children,
  active,
  onClick
}) => {
  return (
    <a
      className={cn(
        `label-medium flex flex-1 select-none flex-row items-center justify-center gap-2 rounded bg-gray-dark-1100 py-3 transition-all`,
        disabled
          ? `text-gray-dark-1200`
          : active
            ? `bg-white text-black`
            : `cursor-pointer text-white hover:bg-white hover:text-black`
      )}
      onClick={onClick}
    >
      {children}
    </a>
  );
};
